import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownward = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16.6666 10L15.4916 8.82501L10.8333 13.475V3.33334H9.16665V13.475L4.51665 8.81668L3.33331 10L9.99998 16.6667L16.6666 10Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowDownward);
export default ForwardRef;
